import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
    return (
        <footer
            className="flex overflow-hidden flex-col justify-center items-center px-16 py-32 w-full max-md:px-5 max-md:py-24 max-md:max-w-full"
            style={{
                background: 'rgb(6, 0, 102)',
                backgroundImage: 'linear-gradient(0deg, rgba(6, 0, 102, 1) 0%, rgba(2, 0, 34, 1) 35%)',
            }}>
            <div className="mb-0 w-full max-w-[1215px] max-md:mb-2.5 max-md:max-w-full">
                <div className="flex gap-5 max-md:flex-col">
                    <div className="flex flex-col w-[40%] max-md:ml-0 max-md:w-full">
                        <div className="flex grow gap-2 items-end text-white max-md:mt-10">
                            <div className="flex flex-col items-start self-stretch">
                                <Link to="/">
                                    <div className="flex gap-1 justify-center items-center self-start text-2xl font-extrabold leading-none">
                                        <img
                                            loading="lazy"
                                            src="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/ddc1516152425ac430ab66d1f7edd9dfeb66a8cba30f3f35194b98af38cd8bf4?apiKey=e485b3dc4b924975b4554885e21242bb&"
                                            alt="Moodeng Credit logo"
                                            className="object-contain shrink-0 self-start aspect-[0.87] w-[34px]"
                                        />
                                        <span className="self-stretch my-auto text-white">Moodeng Credit</span>
                                    </div>
                                </Link>
                                <p className="self-stretch mt-5 text-lg leading-tight text-neutral-100 max-md:mr-2.5">
                                    FUTURE OF ONCHAIN CREDIT
                                </p>
                                <div className="flex gap-2 self-stretch text-xs tracking-normal leading-none text-neutral-100">
                                    <img
                                        className="object-contain mt-10 mr-5 aspect-square w-[30px]"
                                        alt="Link"
                                        src="https://c.animaapp.com/VPWnEuWR/img/link.svg"
                                    />
                                    <img
                                        className="object-contain mt-10 mr-5 aspect-square w-[30px]"
                                        alt="Link SVG"
                                        src="https://c.animaapp.com/VPWnEuWR/img/link---svg.svg"
                                    />
                                    <img
                                        className="object-contain mt-10 mr-5 aspect-square w-[30px]"
                                        alt="Link SVG"
                                        src="https://c.animaapp.com/VPWnEuWR/img/link---svg-1.svg"
                                    />
                                    <img
                                        className="object-contain mt-10 mr-5 aspect-square w-[30px]"
                                        alt="Link"
                                        src="https://c.animaapp.com/VPWnEuWR/img/link-1.svg"
                                    />
                                </div>
                                <small className="mt-10 text-xs tracking-normal leading-relaxed">
                                    Copyright © 2025 Moodeng Credit | All rights reserved
                                </small>
                                <nav className="flex gap-2 self-stretch mt-1.5 text-xs tracking-normal leading-none text-neutral-100">
                                    <Link to="/privacy" className="grow">Privacy Policy</Link>
                                    <span>|</span>
                                    <Link to="/terms">Terms & Conditions</Link>
                                    <span>|</span>
                                    <Link to="/acceptable-use">Acceptable Use</Link>
                                    <span>|</span>
                                    <Link to="/dmca">DMCA</Link>
                                </nav>
                            </div>
                        </div>
                    </div>

                    <nav className="flex flex-wrap gap-10 items-start mt-3 text-lg text-neutral-100 max-md:mt-10 max-md:max-w-full">
                        <div className="flex flex-col justify-center items-start whitespace-nowrap w-[125px]">
                            <Link to="/guide#guide"><h3 className="self-stretch text-xl text-white">GUIDE</h3></Link>
                            <Link to="/guide#system" className="mt-6 leading-tight text-center">SYSTEM</Link>
                            <Link to="/guide#rules" className="mt-6 leading-tight text-center">RULES</Link>
                            <Link to="/guide#web3" className="mt-6 leading-tight text-center">WEB3</Link>
                        </div>

                        <div className="flex flex-col justify-center items-start whitespace-nowrap w-[125px]">
                            <Link to="/benefits#benefits"><h3 className="self-stretch text-xl text-white">BENEFITS</h3></Link>
                            <Link to="/benefits#why-us" className="mt-6 leading-tight text-center">WHY US?</Link>
                            <Link to="/benefits#mission" className="mt-6 leading-tight text-center">MISSION</Link>
                        </div>

                        <div className="flex flex-col justify-center items-start whitespace-nowrap w-[125px]">
                            <Link to="/whylend#why-lend"><h3 className="self-stretch text-xl text-white">WHY LEND</h3></Link>
                            <Link to="/whylend#problem" className="mt-6 leading-tight text-center">PROBLEM</Link>
                            <Link to="/whylend#market" className="mt-6 leading-tight text-center">MARKET</Link>
                            <Link to="/whylend#features" className="mt-6 leading-tight text-center">FEATURES</Link>
                        </div>

                        <div className="flex flex-col justify-center items-start whitespace-nowrap w-[125px]">
                            <Link to="/dashboard#request"><h3 className="self-stretch text-xl text-white">REQUEST</h3></Link>
                            <Link to="/dashboard#request" className="mt-6 leading-tight text-center">BORROW</Link>
                            <Link to="/dashboard#request" className="mt-6 leading-tight text-center">LEND</Link>
                        </div>
                    </nav>
                </div>
            </div>
        </footer >
    );
}
